module.exports = __webpack_public_path__ + "static/media/user_input.9622d7d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/GddTool/user_input.png
// module id = 1675
// module chunks = 0